import ContactUs from './ContactUs';
import { ContactUsProps, ContactUsValueProps } from './types';

export type { ContactUsProps, ContactUsValueProps };
export default ContactUs;
